export default "__VITE_ASSET__CixTHrm3__"